<template>
    <div class="support-form" @click.prevent="openSupportModal">
        <IconQuestion
            v-if="!idea"
            v-tooltip="{
                content: $t('support.tooltip'),
                distance: 20,
            }"
        />
        <button v-else class="support-form__outlined-button">{{ $t('support.ideabutton') }}</button>
        <portal to="modals">
            <Modal
                v-if="showModal"
                :title="idea ? $t('support.ideasend') : $t('support.send')"
                name="support"
                class="support-form__modal"
                @closed="onClose"
            >
                <template #content>
                    <div class="support-form__inner">
                        <Spinner v-if="status === 'loading'" />
                        <form
                            v-if="status !== 'success'"
                            class="form support-form__form"
                            @submit.prevent="sendMessage"
                        >
                            <div v-if="!idea" class="support-form__notice">
                                <div style="margin-bottom: 10px">
                                    <router-link class="link" to="/faq">
                                        {{ $t('support.faq') }}
                                    </router-link>
                                </div>
                                {{ $t('support.answer') }}
                            </div>
                            <div class="form-group">
                                <label class="form-group__label">{{ $t('support.label') }}</label>
                                <textarea
                                    v-model="message"
                                    class="form-group__textarea support-form__textarea"
                                    cols="30"
                                    :placeholder="$t('support.placeholder')"
                                />
                            </div>
                            <div class="support-form__buttons">
                                <button
                                    type="submit"
                                    :disabled="status === 'loading' && !message"
                                    :class="{ 'is-disabled': !message }"
                                    class="button button--big button-round"
                                >
                                    {{ $t('misc.send') }}
                                </button>
                            </div>
                        </form>
                        <div v-if="status === 'success'" class="support-form__success">
                            <p>{{ $t('support.success') }}</p>
                            <span>{{ $t('support.email') }}</span>
                            <a href="mailto:hello@speechki.org" class="link">hello@speechki.org</a>
                        </div>
                    </div>
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { IconQuestion } from '@speechki-frontend/shared/ui/icons';
import { Modal } from '@speechki-frontend/shared/ui/modals';

import { sendMessageToSupport } from '@speechki-frontend/core/misc/api/support';

export default {
    name: 'SupportForm',
    components: {
        IconQuestion,
        Modal,
    },
    props: {
        idea: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            message: '',
            status: null,
            showModal: false,
        };
    },
    methods: {
        openSupportModal() {
            this.showModal = true;
        },
        async sendMessage() {
            try {
                this.status = 'loading';
                await sendMessageToSupport({
                    text: this.message,
                });
                this.status = 'success';
            } catch (error) {
                this.status = null;
                console.log(error);
            }
        },
        onClose() {
            this.status = null;
            this.message = '';
            this.showModal = false;
        },
    },
};
</script>

<style lang="scss" src="./SupportForm.scss"></style>
